import { useEffect, useRef, useState } from 'react';

/**
 * Returns true until both `loading` is false AND at least `minMs` have elapsed
 * since loading last became true. Ensures loaders never flash too briefly.
 */
export function useMinLoading(loading: boolean, minMs = 500): boolean {
	const [minElapsed, setMinElapsed] = useState(!loading);
	const timerRef = useRef<ReturnType<typeof setTimeout> | null>(null);

	useEffect(() => {
		if (loading) {
			setMinElapsed(false);
			if (timerRef.current) clearTimeout(timerRef.current);
			timerRef.current = setTimeout(() => setMinElapsed(true), minMs);
		}
		// No cleanup here — let the timer run to completion even after loading flips false
	}, [loading, minMs]);

	// Cancel only on unmount
	useEffect(() => {
		return () => {
			if (timerRef.current) clearTimeout(timerRef.current);
		};
	}, []);

	return loading || !minElapsed;
}
